import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const PersonalIdCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  gap: 12px;
  .personal-id-file-field {
    width: 288px;
    @media ${DEVICES.sm} {
      width: 100%;
    }
  }
  .ant-upload-list-item-card-actions {
    display: flex;
    & > button {
      padding: 0 20px;
      & > div {
        width: 15px;
      }
    }
  }
`;
